import React from 'react';
import './TournamentBracket.css';
import MatchCard from './MatchCard';

const TournamentBracket = ({ tournamentData, onPlayerClick, onMatchClick }) => {
  const getMatchFormat = (round) => {
    if (round === 'final') return 'Best of 7';
    if (round === 'semiFinals') return 'Best of 5';
    return 'Best of 3';
  };

  return (
    <div className="tournament-bracket">
      <h2 className="bracket-title">Tournament Bracket</h2>
      
      {/* Round of 16 */}
      {tournamentData.roundOf16 && tournamentData.roundOf16.length > 0 && (
        <div className="bracket-round">
          <div className="round-header">
            <h3>Group of 16</h3>
            <span className="match-format">{getMatchFormat('roundOf16')}</span>
          </div>
          <div className="matches-grid">
            {tournamentData.roundOf16.map((match) => (
              <MatchCard
                key={match.id}
                match={match}
                round="roundOf16"
                onPlayerClick={onPlayerClick}
                onMatchClick={(m) => onMatchClick(m, 'roundOf16')}
              />
            ))}
          </div>
        </div>
      )}

      {/* Group of 8 */}
      {tournamentData.groupOf8 && tournamentData.groupOf8.length > 0 && (
        <div className="bracket-round">
          <div className="round-header">
            <h3>Group of 8</h3>
            <span className="match-format">{getMatchFormat('groupOf8')}</span>
            {tournamentData.groupOf8.some(m => m.isPotential) && (
              <span className="potential-note">Showing potential matchups</span>
            )}
          </div>
          <div className="matches-grid">
            {tournamentData.groupOf8.map((match) => (
              <MatchCard
                key={match.id}
                match={match}
                round="groupOf8"
                onPlayerClick={onPlayerClick}
                onMatchClick={(m) => onMatchClick(m, 'groupOf8')}
              />
            ))}
          </div>
        </div>
      )}

      {/* Quarter Finals */}
      {tournamentData.quarterFinals && tournamentData.quarterFinals.length > 0 && (
        <div className="bracket-round">
          <div className="round-header">
            <h3>Quarter Finals</h3>
            <span className="match-format">{getMatchFormat('quarterFinals')}</span>
            {tournamentData.quarterFinals.some(m => m.isPotential) && (
              <span className="potential-note">Showing potential matchups</span>
            )}
          </div>
          <div className="matches-grid">
            {tournamentData.quarterFinals.map((match) => (
              <MatchCard
                key={match.id}
                match={match}
                round="quarterFinals"
                onPlayerClick={onPlayerClick}
                onMatchClick={(m) => onMatchClick(m, 'quarterFinals')}
              />
            ))}
          </div>
        </div>
      )}

      {/* Semi Finals */}
      {tournamentData.semiFinals && tournamentData.semiFinals.length > 0 && (
        <div className="bracket-round">
          <div className="round-header">
            <h3>Semi Finals</h3>
            <span className="match-format">{getMatchFormat('semiFinals')}</span>
            {tournamentData.semiFinals.some(m => m.isPotential) && (
              <span className="potential-note">Showing potential matchups</span>
            )}
          </div>
          <div className="matches-grid semi-finals">
            {tournamentData.semiFinals.map((match) => (
              <MatchCard
                key={match.id}
                match={match}
                round="semiFinals"
                onPlayerClick={onPlayerClick}
                onMatchClick={(m) => onMatchClick(m, 'semiFinals')}
              />
            ))}
          </div>
        </div>
      )}

      {/* Final */}
      {tournamentData.final && (
        <div className="bracket-round final-round">
          <div className="round-header">
            <h3>Final</h3>
            <span className="match-format">{getMatchFormat('final')}</span>
            {tournamentData.final.isPotential && (
              <span className="potential-note">Showing potential matchup</span>
            )}
          </div>
          <div className="matches-grid final-match">
            <MatchCard
              match={tournamentData.final}
              round="final"
              onPlayerClick={onPlayerClick}
              onMatchClick={(m) => onMatchClick(m, 'final')}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TournamentBracket;
